import AuthLayout, { AuthLayoutProps } from './AuthLayout';

export type { AuthLayoutProps };
export default AuthLayout;
